module.exports = __webpack_public_path__ + "img/banner.05e7b000.png";